export default {
    signIn: "Entrar",
    signOut: "sair",
    enter: "Digitar",
    submit: "Submeter",
    clickToEnter: "Clique para entrar"
}